import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { CompaniesDataService, CompaniesColumnsService } from '../../../services';
import { Company, CompaniesResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class CompanyDetailsComponent implements OnInit, OnDestroy {

  public company: Company = {};
  public companies: Company[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private companiesDataService: CompaniesDataService,
    private companiesColumnsService: CompaniesColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Company - Details');
        this.getCompany(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.company !== 'undefined') {
      this.company = this.dynamicDialogConfig.data.company;
    }
    this.columns = this.companiesColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getCompany(id: number): void {
    this.isLoading = true;
    this.companiesDataService.getCompany(id).subscribe((response: Company|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.company = response;
      }
    });
  }

  list() {
    this.router.navigate(['/companies']);
  }

  add() {
    this.router.navigate(['/companies/add']);
  }

  edit() {
    this.router.navigate(['/companies/edit/' + this.company.id]);
  }

}
@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogCompanyDetailsComponent extends CompanyDetailsComponent {
}

